import { getPagePath, NEXT_PAGE } from "../helpers/pageLinkSelectors";

export const getNextPagePath = (state) =>
  getPagePath({ state, direction: NEXT_PAGE });
